import React from 'react';
import { TabbedShowLayout, Tab, TextField, ReferenceField, ReferenceManyField, Pagination } from 'react-admin';
import Box from '@mui/material/Box';

import Show from '../common/views/Show';
import InvoiceRow from '../invoices/InvoiceRow';

const InvoiceList = (props) => (
	<Box>
		<ReferenceManyField {...props} reference="invoices" target="invoicing_address_id" pagination={<Pagination />} filter={{ archived: false }}>
			<InvoiceRow />
		</ReferenceManyField>
	</Box>
);

const AddressShow = props => (
	<Show {...props}>
		<TabbedShowLayout>
			<Tab label="summary">
				<TextField source="name" />
				<TextField source="vat_number" />
				<ReferenceField label="Customer" source="customer_id" reference="customers" link="show" allowEmpty>
					<TextField source="name" />
				</ReferenceField>
				<TextField source="street" />
				<TextField source="street_bis" />
				<TextField source="number" />
				<TextField source="box" />
				<TextField source="zipcode" />
				<TextField source="city" />
				<TextField source="country" />
				<TextField source="email" />
				<TextField source="phone" />
			</Tab>
			<Tab label="Invoices" path="invoices">
				<InvoiceList label={false} />
			</Tab>
		</TabbedShowLayout>
	</Show>
);

export default AddressShow;